/**
 * Local (instant) persistence of Travel India progress. The server is the
 * source of truth for resume, but localStorage gives an immediate restore on
 * reload and a fallback when the network is slow.
 */

function persistKey() {
  try {
    const raw = localStorage.getItem("userData");
    if (!raw) return null;
    const user = JSON.parse(raw);
    if (!user?.userId || !user?.sessionId) return null;
    return `travel_game_${user.sessionId}_${user.userId}`;
  } catch {
    return null;
  }
}

const EMPTY = { currentRound: 0, points: 0, elapsedSec: 0, answers: {}, completed: false };

export function saveTravelSession(state) {
  const key = persistKey();
  if (!key) return;
  const payload = {
    currentRound: state.currentRound ?? 0,
    points: state.points ?? 0,
    elapsedSec: state.elapsedSec ?? 0,
    answers: state.answers && typeof state.answers === "object" ? state.answers : {},
    completed: !!state.completed,
  };
  try {
    localStorage.setItem(key, JSON.stringify(payload));
  } catch {
    /* ignore */
  }
}

export function readTravelSession() {
  const key = persistKey();
  if (!key) return { ...EMPTY };
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return { ...EMPTY };
    const parsed = JSON.parse(raw);
    return {
      currentRound: Number.parseInt(String(parsed?.currentRound ?? "0"), 10) || 0,
      points: Number.parseInt(String(parsed?.points ?? "0"), 10) || 0,
      elapsedSec: Number.parseInt(String(parsed?.elapsedSec ?? "0"), 10) || 0,
      answers: parsed?.answers && typeof parsed.answers === "object" ? parsed.answers : {},
      completed: !!parsed?.completed,
    };
  } catch {
    return { ...EMPTY };
  }
}

export function clearTravelSession() {
  const key = persistKey();
  if (!key) return;
  try {
    localStorage.removeItem(key);
  } catch {
    /* ignore */
  }
}
